import React, { useState, useEffect } from "react";
import PreventClickjacking from "./PreventClickjacking";
import Masters from "./masters/Masters";
import Login from "./login";
import UserResetPassword from "./user/UserResetPassword";
import UserForgotPassword from "./user/UserForgotPassword";
import UserChangePassword from "./user/UserChangePassword";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faKeyboard,
  faCog,
  faEye,
  faFile,
  faFileAlt,
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink,
  useRouteMatch,
  useParams,
  Redirect,
} from "react-router-dom";
import CreateLease from "./createLease/CreateLease";
import AmendLease from "./amendLease/CreateLease";
import ViewLease from "./viewLease/ViewLease";
import Reports from "./reports/Reports";
import LeaseSummary from "./viewLease/LeaseSummary";

import { hasAccess } from "./utils/index";
import ProtectedRoute from "./utils/ProtectedRoute";

import BottomNav from "./layout/BottomNav";
import InvoiceValidation from "./invoiceValidation/InvoiceValidation";
import TransactionComponent from "./transaction/Transactions";

import Alerts from "./user/alerts/Alerts";
import UserNotification from "./user/alerts/UserNotification";

import OutflowComponent from "./outflow/listing";
import OutflowCreateComponent from "./outflow/create";

import CloseDeals from "./closeDeals/create";
import CloseDealsCreate from "./closeDeals/create";
import Dashboard from "./dashboard/Dashboard";
import Leads from "./leads/Leads";
import MyProfile from "./user/MyProfile";
import TopHeader from "./layout/TopHeader";
function bottomNav() {
  return (
    <div className="bottomNav">
      <ul>
        <li>
          <Switch>
            <Route path="/about">About</Route>
            <Route path="/masters">Home / Masters</Route>
            <Route path="/createlease">Home / Create Lease</Route>
            <Route path="/view-lease">Home / View Lease</Route>
            <Route path="/lease-summary">Home / View Summary</Route>
            <Route path="/reports">Home / reports</Route>
            <Route path="/amendlease">Home</Route>
            <Route path="/user/alerts/alerts">Home</Route>
            {/* <Route path="/Not-decided-yet">Home</Route> */}
          </Switch>
        </li>
        {hasAccess(["admin", "user"]) && (
          <li>
            <NavLink
              activeClassName="selected"
              to="/masters"
              activeStyle={{
                fontWeight: "bold",
                color: "white",
              }}
            >
              <FontAwesomeIcon icon={faCog} />
            </NavLink>
          </li>
        )}
        {hasAccess(["user", "admin"]) && (
          <li>
            <NavLink to="/createlease" activeClassName="selected">
              <FontAwesomeIcon icon={faKeyboard} />
            </NavLink>
          </li>
        )}
        <li>
          <NavLink to="/lease-summary" activeClassName="selected">
            <FontAwesomeIcon icon={faEye} />
          </NavLink>
        </li>
        <li>
          <NavLink to="/reports" activeClassName="selected">
            <FontAwesomeIcon icon={faFileAlt} />
          </NavLink>
        </li>
        <li>
          <NavLink to="/invoice-validation" activeClassName="selected">
            <FontAwesomeIcon icon={faCommentDots} />
          </NavLink>
        </li>
      </ul>
    </div>
  );
}
function showMenu(access) {
  console.log("menu");
  if (access) {
    return (
      <div>
        {bottomNav()} <CreateLease />
      </div>
    );
  } else return <Login />;
}
export default function App() {
  //let match = useRouteMatch();
  return (
    <Router>
       <PreventClickjacking />
      <div>
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/masters">
            <BottomNav /> <Masters />
          </Route>
          <Route path="/leads">
            {/* {bottomNav()}   */}
            <BottomNav />
            <Leads />
          </Route>
          {/* <ProtectedRoute path="/masters" component={Masters} roles={['user']} /> */}
          {/* <ProtectedRoute path="/masters" component={Masters} roles={['user']} />

          <ProtectedRoute path="/createlease" component={CreateLease} roles={[ 'user']} />
            
          <ProtectedRoute path="/view-lease" component={ViewLease}  roles={['admin','user']}/>

          <ProtectedRoute path="/view-lease/:brand/:state" component={ViewLease}  roles={['admin','user']}/>

          <ProtectedRoute path="/reports" component={Reports}  roles={['admin','user']}/>

          <ProtectedRoute path="/lease-summary" component={LeaseSummary}  roles={['admin','user']}/> */}

          {/* <ProtectedRoute path="/createlease" component={CreateLease} roles={[ 'user']} /> */}
          <Route path="/createlease">
            {/* {bottomNav()}   */}
            <BottomNav />
            <CreateLease />
          </Route>
          <Route path="/amendlease">
            {/* {bottomNav()}   */}
            <BottomNav />
            <AmendLease />
          </Route>
          <Route path="/checklease">
            {/* {bottomNav()}   */}
            <BottomNav />
            <AmendLease />
          </Route>
          <Route path="/renewlease">
            {/* {bottomNav()}   */}
            <BottomNav />
            <AmendLease />
          </Route>
          <Route path="/extendlease">
            {/* {bottomNav()}   */}
            <BottomNav />
            <AmendLease />
          </Route>

          <Route path="/lease-summary/view-lease">
            <BottomNav />
            {/* {bottomNav()}   */}
            <ViewLease />
          </Route>
          <Route path="/view-lease/:brand/:state">
            <BottomNav />
            {/* {bottomNav()} */}
            <ViewLease />
          </Route>
          <Route path="/reports">
            <BottomNav />
            {/* {bottomNav()} */}
            <Reports />
          </Route>
          <Route path="/lease-summary">
            {/* {BottomNav()} */}
            <BottomNav />
            <LeaseSummary />
          </Route>
          <Route path="/invoice-validation">
            {/* {BottomNav()} */}
            <BottomNav />
            <InvoiceValidation />
          </Route>

          <Route path="/transactions">
            {/* {BottomNav()} */}
            <BottomNav />
            <TransactionComponent />
          </Route>

          <Route path={`/user/reset-password`}>
            <UserResetPassword />
          </Route>
          <Route path={`/user/change-password`}>
            <UserChangePassword />
          </Route>

          <Route path={`/user/alerts/alerts1`}>
            <Alerts />
            <BottomNav />
          </Route>
          <Route path={`/user/alerts/alerts`}>
            <UserNotification />
            <BottomNav />
          </Route>
          <Route path={`/outflow/update/:id`}>
            <OutflowCreateComponent />
            <BottomNav />
          </Route>
          <Route path={`/outflow/create/:id`}>
            <OutflowCreateComponent />
            <BottomNav />
          </Route>
          <Route path={`/outflow/create`}>
            <OutflowCreateComponent />
            <BottomNav />
          </Route>
          <Route path={`/outflow`}>
            <OutflowComponent />
            <BottomNav />
          </Route>
          <Route path={`/user/my-profile`}>
            <TopHeader />
            <MyProfile />
            <BottomNav />
          </Route>
          <Route path={`/user/forgot-password`}>
            <UserForgotPassword />
          </Route>
          <Route path={`/dashboard`}>
            <Dashboard />
          </Route>
          {/* <Route path={`/close-deals/create/:id`}>
            <BottomNav />
            <CloseDealsCreate />
          </Route> */}
          {/* <Route path={`/close-deals/create`}>
            <BottomNav />
            <CloseDealsCreate />
          </Route> */}
          {/* <Route path={`/close-deals`}>
            <BottomNav />
            <CloseDeals />
          </Route>  */}
          <Route path="/close-deals">
            <BottomNav />
            <CloseDeals />
          </Route>

          <Route path="/">
            <Login />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

function About() {
  return <h2>About</h2>;
}
